export default "__VITE_ASSET__A4R6OXsQ__"